$(function(){
  // #で始まるリンクをクリックした場合
  $('.cc2_1_kyoto-limited-item_intro a[href^="#"]').click(function(){
    // 例えばヘッダーの高さを事前に取得
    const h = $('.cc2_1_kyoto-limited-item_spacer').outerHeight(); // 追加
    // adjust に代入するとヘッダーの高さを取得してズラせる。
    let adjust = h; // 変更
    // スクロールの速度（ミリ秒）
    const speed = 500;
    // リンク先を取得してhrefという変数に代入
    const href= $(this).attr("href");
    // リンク先にidがある場合ターゲットとして値を取得
    const target = $(href == "#" || href == "" ? 'html' : href);
    // ターゲットの位置を取得し、調整がある場合は位置の調整を行う
    const position = target.offset().top + adjust;
    // スクロール実行
    $('body,html').animate({scrollTop:position}, speed, 'swing');
    return false;
  });
});


$(window).on('scroll', function(){
	const scrollTop = $(window).scrollTop();
	const scroll_point = (scrollTop - 100) / 500.0;
	const scroll_point_after = (scrollTop - 900) / 500.0;
	if(scroll_point){
		$('.cc2_1_kyoto-limited-item_mv_mask').css('opacity', scroll_point);
		$('.cc2_1_kyoto-limited-item_mv_text').css('opacity', 1 - scroll_point);
	}
	if(scroll_point_after){
		$('.cc2_1_kyoto-limited-item_mv_text2').css('opacity', scroll_point_after);
	}
});

$(window).scroll(function() {
const scroll = $(window).scrollTop();
const h = $(window).height();
	if (scroll >= 2*h) {
		$('.cc2_1_kyoto-limited-item_mv').addClass('mv_wrapper_absolute');
		$('.cc2_1_kyoto-limited-item_spacer').addClass('mv_wrapper_none2');
		$('.cc2_1_kyoto-limited-item_mv_text2').addClass('mv_wrapper_none3');
		$('.cc2_1_kyoto-limited-item_intro').addClass('mv_wrapper_none4');
		$('.cc2_1_kyoto-limited-item_mv_scrolldown').addClass('mv_wrapper_none5');
	} else {
		$('.cc2_1_kyoto-limited-item_mv').removeClass('mv_wrapper_absolute');
		$('.cc2_1_kyoto-limited-item_spacer').removeClass('mv_wrapper_none2');
		$('.cc2_1_kyoto-limited-item_mv_text2').removeClass('mv_wrapper_none3');
		$('.cc2_1_kyoto-limited-item_intro').removeClass('mv_wrapper_none4');
		$('.cc2_1_kyoto-limited-item_mv_scrolldown').removeClass('mv_wrapper_none5');
	}
});
	
$(function() {
	const mv_wrapper_none = $('.cc2_1_kyoto-limited-item_mv_wrapper');
	$(window).on('load scroll', function(){
		if($(this).scrollTop() > 4000) {
			mv_wrapper_none.addClass('mv_wrapper_none');
		}else{
			mv_wrapper_none.removeClass('mv_wrapper_none');
		}
	});
});
